module.exports = (__webpack_require__(5674))(540);